import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { API_URL } from '../../configurations/server-config';
import { LoginRequestModel } from '../../models/authentication/login-request-model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private jwttoken: any = null;
  private role: any;
  constructor(
    private http: HttpClient,
    private jwthelper: JwtHelperService,
    private httpbackend: HttpBackend,
    private router: Router
  ) {}

  loginUser(loginRequestPayload: LoginRequestModel): any {
    this.http = new HttpClient(this.httpbackend);
    return this.http.post(`${API_URL}/login`, loginRequestPayload, {
      observe: 'response',
    });
  }

  logout(): void {
    // clear token remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.jwttoken = null;
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('userRole');
    localStorage.removeItem('activeFacility');
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }

  saveToken(jwt: string): any {
    this.jwttoken = jwt;
    localStorage.setItem('token', jwt);

    const decodedToken = this.jwthelper.decodeToken(this.jwttoken);
          // console.log("subject "+decodedToken.sub);
    // let userDetails = JSON.parse(decodedToken.sub);
    const userDetails = (decodedToken.sub);
    this.role = decodedToken.authority;
    localStorage.setItem('userRole', decodedToken.roles[0].authority);
    localStorage.setItem('loggedInUser', JSON.stringify(userDetails));

    return this.role;
  }

  gettoken(): any{
    return localStorage.getItem('token');
  }

  isAuthenticated(): boolean {
    const token = this.gettoken();
    // console.log('test token validity', token);
    if (token != null) {
      // console.log('test token validity', token);
      if (!this.jwthelper.isTokenExpired(token)){
      return true;
      }
    }
    localStorage.removeItem('token');
    localStorage.removeItem('userinfo');
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('userRole');
    return false;
  }

  getLoggedInUser(): any {
    // return JSON.parse(localStorage.getItem('loggedInUser'));
  }

  getToken(): any {
    return localStorage.getItem('token');
  }
  getLoginUserRole(): any {
    return localStorage.getItem('userRole');
  }

  passwordResetRequest(email: string): any {}

  changePassword(email: string, currentPwd: string, newPwd: string): any {}

  passwordReset(
    email: string,
    token: string,
    password: string,
    confirmPassword: string
  ): any {}

  saverole(value: any): any {
    this.http = new HttpClient(this.httpbackend);
    return this.http.post(`${API_URL}/saveroles`, value, {
      observe: 'response',
    });
  }
}
